<h2 cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="dialog-title" mat-dialog-title>
  <span>{{ data.title }}</span>
  <button class="dialog-close" mat-icon-button aria-label="Close" type="button" (click)="onCancel()">
    <mat-icon>close</mat-icon>
  </button>
</h2>

<mat-dialog-content class="dialog-content">
  <div class="confirm-dialog-content">
    @if (data.showWarningIcon) {
    <mat-icon class="warning-icon" color="warn">warning</mat-icon>
    }
    <span class="confirm-message">{{ data.message }}</span>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="dialog-actions">
  <button matButton="filled" (click)="onCancel()">
    {{ data.cancelText || 'No' }}
  </button>
  <button cdkFocusInitial class="error" matButton="filled" [color]="data.confirmColor || 'warn'"
    (click)="onConfirm()">
    {{ data.confirmText || 'Yes' }}
  </button>
</mat-dialog-actions>
